import api from '../index'

const baseURL = 'https://ydsys1.s136.ailo.vip/api'

// 开发模式：设置为 true 时返回模拟数据，不调用真实API
const DEV_MODE = false

function baseRequest(url: string, data: any, config: any = {}, method: string = 'post') {
  // 开发模式：返回模拟数据
  if (DEV_MODE) {
    return Promise.resolve({
      code: 200,
      message: 'OK (开发模式)',
      data: getMockData(url),
    })
  }

  const useSynthesis = useSynthesisStore()
  const headers = {
    'x-token': useSynthesis.token,
  }
  if (method === 'post') {
    return api.post(url, data, { headers, baseURL, isSynthesis: true, isSynthesisLoading: true, ...config })
  }
  else {
    return api({
      method: 'get',
      url,
      params: data,
      ...config,
      headers,
      baseURL,
      isSynthesis: true,
    })
  }
}

// 模拟数据生成函数
function getMockData(url: string) {
  // 根据不同的接口返回不同的模拟数据
  if (url.includes('/arm/state') || url.includes('/filmsealing/state') ||
      url.includes('/hiwo/state') || url.includes('/lc/state') || url.includes('/sowo/state')) {
    return { stateName: '空闲' }
  }
  if (url.includes('/task/page')) {
    return {
      records: [],
      total: 0,
      size: 10,
      current: 1,
    }
  }
  if (url.includes('/reaction') || url.includes('/routes')) {
    return {
      id: 'mock-id',
      name: '模拟实验',
      status: 1,
    }
  }
  // 默认返回空对象
  return {}
}
// 上传文件接口
export const publicUploadFileUrl = '/my/upload'

/**
 * @description 获取合成化学实验token
 * @returns {Promise} 请求结果
 */
export function reqSynthesisToken(data?: any) {
  // 开发模式：返回模拟token
  if (DEV_MODE) {
    return Promise.resolve({
      status: 1,
      code: 200,
      message: 'OK (开发模式)',
      data: {
        token: 'mock-synthesis-token-' + Date.now(),
      },
    })
  }
  return api.post('/common/lab/getToken', data)
}

/**
 * @param {object} data 传参
 * @description 获取仪器状态
 * @returns {Promise} 请求结果
 */
export function getInstrumentStatusArm(data: any) {
  return baseRequest('/arm/state', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 获取仪器状态
 * @returns {Promise} 请求结果
 */
export function getInstrumentStatusFilmsealing(data: any) {
  return baseRequest('/filmsealing/state', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 获取仪器状态
 * @returns {Promise} 请求结果
 */
export function getInstrumentStatusHiwo(data: any) {
  return baseRequest('/hiwo/state', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 获取仪器状态
 * @returns {Promise} 请求结果
 */
export function getInstrumentStatusLc(data: any) {
  return baseRequest('/lc/state', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 获取仪器状态
 * @returns {Promise} 请求结果
 */
export function getInstrumentStatusSowo(data: any) {
  return baseRequest('/sowo/state', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 获取结果目标反应检索
 * @returns {Promise} 请求结果
 */
export function getFyOutcome(data: any) {
  return baseRequest('/reaction', data)
}
/**
 * @param {object} data 传参
 * @description 获取结果目标分子推荐
 * @returns {Promise} 请求结果
 */
export function getOutcome(data: any) {
  return baseRequest('/routes', data)
}
/**
 * @param {object} data 传参
 * @description 反应条件推荐结果获取
 * @returns {Promise} 请求结果
 */
export function getReactionResult(data: any) {
  return baseRequest('/reaction', data)
}
/**
 * @param {object} data 传参
 * @description 目标反应提交
 * @returns {Promise} 请求结果
 */
export function getRetrievalRecommendation(data: any) {
  return baseRequest('/routes/reactionInsert', data)
}
/**
 * @param {object} data 传参
 * @description 提交反应条件推荐
 * @returns {Promise} 请求结果
 */
export function submissionReactionConditions(data: any) {
  return baseRequest('/reaction/updateCondition', data)
}
/**
 * @param {object} data 传参
 * @description 获取历史任务列表
 * @returns {Promise} 请求结果
 */
export function getHistoryTaskList(data: any) {
  return baseRequest('/task/page', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 取消实验任务
 * @returns {Promise} 请求结果
 */
export function cancelExperimentTask(data: any) {
  return baseRequest('/task/cancel', data)
}
/**
 * @param {object} data 传参
 * @description 逆合成、结晶平台历史任务文件下载
 * @returns {Promise} 请求结果
 */
export function downloadSynthesisTaskFile(data: any) {
  return baseRequest('/task/attachmentCollection', data)
}
/**
 * @param {object} data 传参
 * @description 反应关联实验获取
 * @returns {Promise} 请求结果
 */
export function getReactionExperiment(data: any) {
  return baseRequest('/reaction/experiment', data)
}
/**
 * @param {object} data 传参
 * @description 根据任务查询选择的逆合成路线
 * @returns {Promise} 请求结果
 */
export function checkDownloadAttachmentCollectionFileStatus(data: any) {
  return baseRequest('/experiment/attachmentCollection', data, { responseType: 'blob' })
}
/**
 * @param {object} data 传参
 * @description 获取实验记录
 * @returns {Promise} 请求结果
 */
export function getExperiment(data: any) {
  return baseRequest('/experiment', data)
}
/**
 * @param {object} data 传参
 * @description 发送邮件
 * @returns {Promise} 请求结果
 */
export function sendEmail(data: any) {
  return baseRequest('/experiment/sendEmail', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function setExperimentStartConfirm(data: any) {
  return baseRequest('/experiment/startConfirm', data)
}
/**
 * @param {object} data 传参
 * @description 更新逆合成确认实验细节的物料文件
 * @returns {Promise} 请求结果
 */
export function updateAttachmentCollectionFile(data: any) {
  return baseRequest('/document/update', data)
}
/**
 * @param {object} data 传参
 * @description 获取功能模块
 * @returns {Promise} 请求结果
 */
export function getFunctionalModule(data: any) {
  return baseRequest('/admin/resourcecategory/pageWithResource', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getLcMethodsList(data: any) {
  return baseRequest('/lcMethodsList', data)
}
/**
 * @param {object} data 传参
 * @description 逆合成-实验记录-检测分析Lc上传
 * @returns {Promise} 请求结果
 */
export function saveLcFileId(data: any) {
  return baseRequest('/analysis/updateLc', data)
}
/**
 * @param {object} data 传参
 * @description 计算分子式
 * @returns {Promise} 请求结果
 */
export function getCalculateFormula(data: any) {
  return baseRequest('/calculateFormula', data)
}
/**
 * @param {object} data 传参
 * @description 计算分子量
 * @returns {Promise} 请求结果
 */
export function getCalculateMw(data: any) {
  return baseRequest('/calculateMw', data)
}
/**
 * @param {object} data 传参
 * @description 获取反应条件推荐结果获取-分子
 * @returns {Promise} 请求结果
 */
export function getFzReactionConditionList(data: any) {
  return baseRequest('/reaction/conditionList', data)
}
/**
 * @param {object} data 传参
 * @description 条件推荐表格选中
 * @returns {Promise} 请求结果
 */
export function reactionConditionSelect(data: any) {
  return baseRequest('/reactioncondition/select', data)
}
/**
 * @param {object} data 传参
 * @description 条件推荐表格取消选中
 * @returns {Promise} 请求结果
 */
export function reactionConditionUnselect(data: any) {
  return baseRequest('/reactioncondition/unselect', data)
}
/**
 * @param {object} data 传参
 * @description AI模型下载接口
 * @returns {Promise} 请求结果
 */
export function downloadModelTemplate(data: any) {
  return baseRequest('/download_model', data)
}
/**
 * @param {object} data 传参
 * @description 模型预测
 * @returns {Promise} 请求结果
 */
export function predict(data: any) {
  return baseRequest('/predict', data)
}
/**
 * @param {object} data 传参
 * @description 模型预测结果详情
 * @returns {Promise} 请求结果
 */
export function getPredictPredictionsDetail(data: any) {
  return baseRequest('/predict/predictions', data)
}
/**
 * @param {object} data 传参
 * @description 开始建模
 * @returns {Promise} 请求结果
 */
export function addAiModeling(data: any) {
  return baseRequest('/modeling/insert', data)
}
/**
 * @param {object} data 传参
 * @description 模型命名
 * @returns {Promise} 请求结果
 */
export function getModelUpdateName(data: any) {
  return baseRequest('/model/updateName', data)
}
/**
 * @param {object} data 传参
 * @description 建模结果查询
 * @returns {Promise} 请求结果
 */
export function getAiModelingInfo(data: any) {
  return baseRequest('/modeling', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getcrystalMolRead(data: any) {
  return baseRequest('/crystalMolRead', data)
}
/**
 * @param {object} data 传参
 * @description 创建实验记录（暂存接口）
 * @returns {Promise} 请求结果
 */
export function saveExperiment(data: any) {
  return baseRequest('/experiment/insert', data)
}
/**
 * @param {object} data 传参
 * @description 更新实验记录
 * @returns {Promise} 请求结果
 */
export function updateExperiment(data: any) {
  return baseRequest('/experiment/update', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getExperimentStart(data: any) {
  return baseRequest('/experiment/start', data)
}
/**
 * @param {object} data 传参
 * @description 获取工作流列表
 * @returns {Promise} 请求结果
 */
export function getWorkflowList(data: any) {
  return baseRequest('/workflow/list', data)
}
/**
 * @param {object} data 传参
 * @description 停止实验
 * @returns {Promise} 请求结果
 */
export function pauseExperiment(data: any) {
  return baseRequest('/experiment/pause', data)
}
/**
 * @param {object} data 传参
 * @description 更新实验工作流
 * @returns {Promise} 请求结果
 */
export function updateWorkflowList(data: any) {
  return baseRequest('/experiment/updateWorkflow', data)
}
/**
 * @param {object} data 传参
 * @description 根据反应查询贝叶斯优化详情
 * @returns {Promise} 请求结果
 */
export function getReactionOptimize(data: any) {
  return baseRequest('/optimize/reaction', data)
}
/**
 * @param {object} data 传参
 * @description 逆合成贝叶斯优化结果查询
 * @returns {Promise} 请求结果
 */
export function getSynthesis_bayesStatus(data: any) {
  return baseRequest('/experiment/optimize', data)
}
/**
 * @param {object} data 传参
 * @description 开始贝叶斯优化
 * @returns {Promise} 请求结果
 */
export function updateOptimizeVars(data: any) {
  return baseRequest('/experiment/updateOptimizeVars', data)
}
/**
 * @param {object} data 传参
 * @description 结果管理-查询实验反应数据
 * @returns {Promise} 请求结果
 */
export function getExperimentBest(data: any) {
  return baseRequest('/experiment/best', data)
}
/**
 * @param {object} data 传参
 * @description 结果管理-反应数据结果解析
 * @returns {Promise} 请求结果
 */
export function getSynthesisParseReactionData(data: any) {
  return baseRequest('/experiment/parseReactionData', data)
}
/**
 * @param {object} data 传参
 * @description 副产物预测
 * @returns {Promise} 请求结果
 */
export function getExperimentUpdateImpurity(data: any) {
  return baseRequest('/experiment/updateImpurity', data)
}
/**
 * @param {object} data 传参
 * @description 副产物预测结果
 * @returns {Promise} 请求结果
 */
export function getExperimentImpurity(data: any) {
  return baseRequest('/experiment/impurity', data, { isSynthesisLoading: false })
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getHplcAnalyze(data: any) {
  return baseRequest('/hplc/analyze', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getHplcPage(data: any) {
  return baseRequest('/hplc/page', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getLcmsAnalyze(data: any) {
  return baseRequest('/lcms/analyze', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getLcmsPage(data: any) {
  return baseRequest('/lcms/page', data)
}
/**
 * @param {object} data 传参
 * @description nmr分析
 * @returns {Promise} 请求结果
 */
export function getNmrAnalyze(data: any) {
  return baseRequest('/nmr/analyze', data)
}
/**
 * @param {object} data 传参
 * @description nmr列表
 * @returns {Promise} 请求结果
 */
export function getNmrPage(data: any) {
  return baseRequest('/nmr/page', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getXrdAnalyze(data: any) {
  return baseRequest('/xrd/analyze', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function getXrdPage(data: any) {
  return baseRequest('/xrd/page', data)
}
/**
 * @param {object} data 传参
 * @description 未知
 * @returns {Promise} 请求结果
 */
export function selectFzRetrosynthesisRoute(data: any) {
  return baseRequest('/xrd/page', data)
}
/**
 * @param {object} data 传参
 * @description 根据任务查询选择的逆合成路线
 * @returns {Promise} 请求结果
 */
export function getTaskRouteSelected(data: any) {
  return baseRequest('/task/routeSelected', data)
}
/**
 * @param {object} data 传参
 * @description 选择目标反应检索条件
 * @returns {Promise} 请求结果
 */
export function getMbfyReactionSelectCondition(data: any) {
  return baseRequest('/reaction/selectCondition', data)
}
/**
 * @param {object} data 传参
 * @description 取消选择目标反应检索条件
 * @returns {Promise} 请求结果
 */
export function getMbfyReactionUnselectCondition(data: any) {
  return baseRequest('/reaction/unselectCondition', data)
}
/**
 * @param {object} data 传参
 * @description 目标反应推荐结果-反应
 * @returns {Promise} 请求结果
 */
export function getFyReactionConditionList(data: any) {
  return baseRequest('/reaction/targetConditionList', data)
}
